module.exports = __webpack_public_path__ + "media/guac_sweepstakes/twitter-social-icon-8c8c9c65.svg";